<template>
    <ac-confirmation-modal :title="'Provider Termination'"
                           :size-class="'modal-md'"
                           :accept-button="'Terminate Provider'" ref="modal">
        <template>
            <form>
                <div class="row">
                    <div class="info-board info-board-blue">
                        <div class="row">
                            <div class="col-lg-12">
                                <p class="text-primary">
                                    <small>
                                        <em>
                                            You are about to terminate the selected provider entity.
                                            Doing so will schedule the provider for immediate termination.
                                            Once the termination is processed, this provider entity will no
                                            longer be able to make changes to their account or accept any new
                                            patients. If you are terminating a parent Network or Clinic, this
                                            process will terminate all providers associated with the entity.
                                            Please Note: Members who have selected a plan associated to this
                                            provider will have their plans scheduled for termination at the end of
                                            the current month.
                                        </em>
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </ac-confirmation-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "TerminationConfirmationModal",
        methods: {
            async showModal({providerEntityId, terminatingChild}) {
                let result = await this.$refs.modal.showModal();
                if (result) {
                    await api.postDataAsJson('ProviderEntity', terminatingChild ? 'TermChild' : 'TermProvider', providerEntityId);
                }
            }
        }
    }
</script>

<style scoped>

</style>